import React, { useMemo } from 'react';
import RMSvgIcon, { RMSvgIconProps } from '../../CommonComponents/RMSvgIcon';
import { IStyle } from 'Styles';
import './styles.scss';
const iconBaseProps: RMSvgIconProps = {
  name: 'FilledArrowDown',
  fill: 'white',
  width: '13.09px',
  height: '6.55px',
};

const ArrowButton = React.memo((props: ArrowButtonProps) => {
  const { onClick, iconProps } = props;
  return (
    <div
      id="controls-rmaccordian-arrowbuton"
      data-testid="controls-rmaccordian-arrowbuton"
      className="arrow-button-style"
      onClick={onClick}
    >
      <RMSvgIcon
        id="rmaccordian-arrow-icon"
        data-testid="rmaccordian-arrow-icon"
        {...iconProps}
      />
    </div>
  );
});

function RMAccordian({ preClick, nextClick, children, style, className = '' }) {
  const arrowButtons = useMemo(
    () => [
      {
        onClick: preClick,
        iconProps: { ...iconBaseProps, style: styles.leftIconRotation },
      },
      {
        onClick: nextClick,
        iconProps: {
          ...iconBaseProps,
          style: styles.rightIconRotation,
        },
      },
    ],
    [preClick, nextClick, iconBaseProps],
  );
  return (
    <div
      id="controls-rmaccordian-container"
      data-testid="controls-rmaccordian-container"
      style={{ ...styles.mainContainer, ...style }}
      className={className}
    >
      <ArrowButton {...arrowButtons[0]} />
      <div
        id="controls-rmaccordian-container-children"
        data-testid="controls-rmaccordian-container-children"
        style={styles.contentContainer}
      >
        {children}
      </div>
      <ArrowButton {...arrowButtons[1]} />
    </div>
  );
}

interface ArrowButtonProps {
  onClick: () => void;
  iconProps: RMSvgIconProps;
}

const styles: IStyle = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '2%',
    paddingRight: '2%',
    height: '17.822%',
    width: '100%',
  },

  leftIconRotation: {
    rotate: '90deg',
  },
  rightIconRotation: {
    rotate: '-90deg',
  },
  contentContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    margin: '0px 1% 0px 1%',
    alignItems: 'center',
  },
};

export default RMAccordian;
